var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.situacao)?_c('span',{class:_vm.textColorClass},[_c('v-icon',{class:("pb-1 " + _vm.textColorClass),attrs:{"right":_vm.iconInRight}},[_vm._v("mdi-circle-medium")]),_vm._v(" "+_vm._s(_vm.description)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }